module.exports = __webpack_public_path__ + "assets/img/season-code-05-87ff99fa.png";